const getIdentifierFhirStructure = (system, code, value) => {
  return {
    use: 'usual',
    type: {
      coding: [
        {
          code: code,
          system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
          userSelected: false,
        },
      ],
    },
    system: system,
    value: value,
  };
};

export { getIdentifierFhirStructure };
